// extracted by mini-css-extract-plugin
module.exports = {"games_list":"items-list_games_list__y4lcW","games_list__item":"items-list_games_list__item__ejE1q"};